export default "__VITE_ASSET__9i8NFFIA__"